// @flow
import type { PhotographerType, PhotographersType } from 'database-helper'

export default class PhotographersApp {
  photographers: PhotographersType

  constructor(photographers: PhotographersType) {
    this.photographers = photographers
  }

  getPhotographeThroughId(id: string): PhotographerType {
    return this.photographers[id]
  }
}


// WEBPACK FOOTER //
// ./src/utils/photographersApp.js